import React from 'react';
import { Card, Space, Tag, Typography } from 'antd';

const { Text } = Typography;

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveText(value) {
  return String(value ?? '').trim();
}

function renderPolicyTag(value, color, label) {
  return value ? <Tag color={color}>{label}: {value}</Tag> : null;
}

export function MessageArtifactPresentationPolicyCard({
  item = {},
  themeTokens,
}) {
  const payload = resolveObject(item.payload);
  const policy = resolveObject(payload.presentation_policy);
  const tokens = resolveObject(themeTokens);
  const primarySurface = resolveText(policy.primary_surface);
  const timelineMode = resolveText(policy.timeline_mode);
  const canvasMode = resolveText(policy.canvas_mode);

  if (![primarySurface, timelineMode, canvasMode].some(Boolean)) {
    return null;
  }

  return (
    <Card
      size="small"
      style={{
        background: tokens.surfaceBg,
        borderColor: tokens.surfaceBorder,
      }}
    >
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Text strong style={{ color: tokens.textPrimary }}>
          Artifact 展示策略
        </Text>
        <Space size={[6, 6]} wrap>
          {renderPolicyTag(primarySurface, 'blue', 'primary_surface')}
          {renderPolicyTag(timelineMode, 'purple', 'timeline_mode')}
          {renderPolicyTag(canvasMode, 'green', 'canvas_mode')}
        </Space>
      </Space>
    </Card>
  );
}

export default MessageArtifactPresentationPolicyCard;
